<script type="text/ecmascript-6">
    import DesignerQuestionDoorColourInternal from "../DesignerQuestionDoorColourInternal.vue";
    import TileQuestion from "../mixin/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionDoorColourInternal,
            TileQuestion,
        ],
    }
</script>
